import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function RouteTransition() {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(true); // show on first mount too
  const [phase, setPhase] = useState("in");
  const timers = useRef([]);

  const runFlash = () => {
    timers.current.forEach(clearTimeout);
    timers.current = [];
    setVisible(true);
    setPhase("in");
    timers.current.push(setTimeout(() => setPhase("out"), 550));
    timers.current.push(setTimeout(() => setVisible(false), 950));
  };

  // Trigger on route (pathname) change — including first mount
  useEffect(() => {
    runFlash();
    return () => {
      timers.current.forEach(clearTimeout);
      timers.current = [];
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  // Trigger on manual event — e.g. clicking the tab you're already on
  useEffect(() => {
    const onFlash = () => runFlash();
    window.addEventListener("tth:flash", onFlash);
    return () => window.removeEventListener("tth:flash", onFlash);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="route-transition"
      aria-hidden
      className={`fixed inset-0 z-[95] bg-black flex items-center justify-center pointer-events-none transition-opacity duration-500 ${
        phase === "in" ? "opacity-100" : "opacity-0"
      }`}
    >
      <img
        src="/brand/tandem-t-logo.png"
        alt=""
        className="w-56 md:w-72 h-auto object-contain animate-[flashIn_500ms_ease-out_both]"
        style={{ mixBlendMode: "screen", filter: "brightness(1.6) contrast(1.15)" }}
      />
      <style>{`
        @keyframes flashIn {
          0%   { opacity: 0; transform: scale(0.94); }
          60%  { opacity: 1; transform: scale(1.01); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </div>
  );
}
